import { Button, Dialog, DialogContent } from '@mui/material'
import React from 'react'
import { AMOUNT_FIELDS, formatTotal, sumAmounts } from '../promoteSpreadAmounts'

export default function ConfirmDialogPs({ open, setOpen, rows, handleAdd }) {
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth='xl'
        >
            <DialogContent>
                <div class="d-flex row align-items-center mb-4">
                    <div class="col-12">
                        <label style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            color: '#3364af',
                        }}>
                            รายการแผนการส่งเสริมการกระจายเมล็ดพันธุ์ข้าว
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 table-responsive-sm ">
                        <table class="table table-bordered table-hover ">
                            <thead class="test" style={{
                                verticalAlign: 'middle !important',
                                backgroundColor: '#F1F3F9 !important',
                                position: 'sticky !important',
                                top: '0 !important',
                                zIndex: '10 !important'
                            }}>
                                <tr>
                                    <th scope="col " rowspan="3" class="text-center" style={{
                                        position: 'inherit',
                                    }}>เดือน</th>
                                    <th scope="col" colSpan={7} className="text-center" style={{
                                        position: 'inherit',
                                    }}>สัดส่วนช่องทางการจำหน่าย</th>
                                    <th scope="col " rowspan="3" class="text-center" style={{
                                        position: 'inherit',
                                    }}>รวม</th>
                                    <th scope="col " rowspan="3" class="text-center" style={{
                                        position: 'inherit',
                                    }}>สถานที่ที่จะส่งเสริม (ระบุจังหวัด)</th>
                                </tr>
                                <tr>

                                    <th scope="col " rowspan="2" class="text-center" style={{
                                        position: 'inherit',
                                    }}>โครงการ/ส่วนราชการ</th>
                                    <th scope="col" colSpan={4} className="text-center" style={{
                                        position: 'inherit',
                                    }}>ตัวแทนจำหน่าย</th>
                                    <th scope="col " colspan="2" class="text-center" style={{
                                        position: 'inherit',
                                    }}>เกษตรกร/กลุ่มเกษตรกร/ร้านค้า</th>
                                </tr>
                                <tr>
                                    <th scope="col " class="text-center" style={{
                                        position: 'inherit',
                                    }}>ราคาเต็ม</th>
                                    <th scope="col " class="text-center" style={{
                                        position: 'inherit',
                                    }}>ลด 5%</th>
                                    <th scope="col" className="text-center" style={{
                                        position: 'inherit',
                                    }}>ลด 7%</th>
                                    <th scope="col " class="text-center" style={{
                                        position: 'inherit',
                                    }}>ลด 8%</th>
                                    <th scope="col " class="text-center" style={{
                                        position: 'inherit',
                                    }}>ราคาเต็ม</th>
                                    <th scope="col " class="text-center" style={{
                                        position: 'inherit',
                                    }}>ส่วนลด</th>
                                </tr>
                            </thead>
                            <tbody class="">
                                {rows?.map((month) =>
                                    <tr >
                                        <td style={{ verticalAlign: 'middle !important' }}>{month?.name}</td>
                                        {AMOUNT_FIELDS.map((field) => (
                                            <td key={field} style={{ verticalAlign: 'middle !important' }}>
                                                {month?.[field] || 0}
                                            </td>
                                        ))}
                                        <td style={{ verticalAlign: 'middle !important' }}>
                                            {formatTotal(sumAmounts(month))}
                                        </td>
                                        <td class="text-center" style={{ verticalAlign: 'middle !important' }}>
                                            {month?.Province?.map((p) => (
                                                <div class="d-flex align-items-center justify-content-center"  >
                                                    {p?.provinceName}
                                                </div>
                                            ))}

                                        </td>
                                    </tr>)}
                            </tbody>
                        </table>
                    </div>


                </div>
                <div class="row mt-4">

                    <div class="col-12 text-end">
                        <Button onClick={() => setOpen(false)} variant='outlined' sx={{ width: "150px", marginRight: '20px' }}>ยกเลิก</Button>
                        <Button onClick={() => handleAdd()} variant='contained' sx={{ width: "150px", marginRight: '20px' }}>ยืนยันการทำรายการ</Button>
                    </div>
                </div>
            </DialogContent >
        </Dialog >
    )
}
